import React, { useState, useContext, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AppContext } from "../../context/AppContext";
import { Dropdown } from "react-bootstrap";
import "../../assets/css/main.scss";
import arrow_right from "../../assets/images/chat/arrow_right.svg";
import more_vertical from "../../assets/images/chat/more_vertical.svg";
import { SearchIconButton } from "../../components/ui";

import { Toast } from "primereact/toast";
import { useMediaQuery } from "react-responsive";
import ChatBox from "./ChatBox";
import ApiConfig from "../../api/ApiConfig";
import { PostCallWithErrorResponse } from "../../api/ApiServices";
import { notifyError, notifySuccess } from "../../toaster/notify";
import ViewMembersModal from "./components/ViewMembersModal";
import CreateSubChannelModal from "./components/CreateSubChannelModal";

const getProjectInitials = (name) => {
  if (!name) return "";
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "";
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const ChevronIcon = () => (
  <svg
    className="comm-channels__chevron-icon"
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M3 1.5L6.5 5L3 8.5"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ProjectChannels = () => {
  const toast = useRef(null);
  const currentRoute = useLocation().pathname;
  const [show, setShow] = useState(false);

  const [showsubChannelModal, setShowsubChannelModal] = useState(false);
  const [subChannelDetails, setSubChannelDetails] = useState({
    name: "",
    description: "",
    members: [],
  });

  const navigate = useNavigate();

  const isMobile = useMediaQuery({
    query: "(max-width: 768px)",
  });

  const [currentTeam, setCurrentTeam] = useState(null);
  const [members, setMembers] = useState([]);

  const {
    currentSChannel,
    getTeams,
    teamMembers,
    loading,
    setLoading,
    sidebar,
    membersArray,
    setSidebar,
    socket,
    setprojectIdTast,
    setSateUpdater,
    projects,
    setProjects,
    activeChat,
    setActiveChat,
    setCurrentSChannel,
    userData,
    ChannelId, setChannelId,
    setSubChannelId
  } = useContext(AppContext);

  const createSubChannel = () => {
    let EMPID = userData.EmpId
    const updatedMembers = [
      ...subChannelDetails.members.map((mem) => mem.id),
    ];
    let body = JSON.stringify({
      schannel_name: subChannelDetails.name,
      schannel_description: subChannelDetails.description,
      channel_id: ChannelId,
      members: updatedMembers,
    });
    if (
      subChannelDetails?.name === "" ||
      subChannelDetails?.description === "" ||
      subChannelDetails?.members.length === 0
    ) {
      notifyError("Please fill all fields");
    } else {
      setLoading(true);
      PostCallWithErrorResponse(ApiConfig.CREATE_SUB_CHANNEL, body)
        .then((res) => {
          setLoading(false);
          if (res.json.status) {
            notifySuccess(res.json.message);
            setShowsubChannelModal(false);
            setSubChannelDetails({ name: "", description: "", members: [] });
            setSateUpdater(true)
            getTeams();
          } else notifyError(res.json.message);
        })
        .catch((err) => {
          setLoading(false);
          notifyError(err);
        });
    }
  };

  const [SubchianlMemberList, setSubchianlMemberList] = useState([]);

  const createSubChannelMember = (id) => {
    let body = JSON.stringify({
      type: "Project",
      channel_id: id,
    });

    setLoading(true);
    PostCallWithErrorResponse(ApiConfig.CREATE_SUB_CHANNEL_ADDMEMBER, body)
      .then((res) => {
        setLoading(false);
        if (res.json.status) {
          setSubchianlMemberList(res.json.data)
        } else
          notifyError(res.json.message);
      })
      .catch((err) => {
        setLoading(false);
        notifyError(err);
      });
  };

  function onSelect(selectedList, selectedItem) {
    setSubChannelDetails({ ...subChannelDetails, members: selectedList });
  }
  function onRemove(selectedList, removedItem) {
    setSubChannelDetails({ ...subChannelDetails, members: selectedList });
  }

  const joinRoom = (schannel_id) => {
    socket.emit("join-room", {
      schannel_id: schannel_id,
    });
  };

  useEffect(() => {
    let newArr =
      projects &&
      Array.isArray(projects) &&
      projects.map((element) => {
        return element?.channel_name === activeChat?.project &&
          activeChat?.project
          ? {
            ...element,
            submenu: true,
          }
          : {
            ...element,
            submenu: false,
          };
      });
    setProjects(newArr);
  }, [activeChat]);

  return (
    <>
      <div
        className={sidebar ? "" : "cx-active"}
        id="cx-main"
      >
        <div className="comm-layout">
          <Toast ref={toast} />

          <aside className="comm-sidebar">
            <div className="comm-sidebar__header">
              <div className="comm-sidebar__title">
                <label>Projects</label>
              </div>
              <div className="comm-sidebar__actions">
                <SearchIconButton
                  size="md"
                  variant="ghost"
                  aria-label="Search projects"
                />
              </div>
            </div>
            <div className="comm-divider"></div>
            <div className="comm-sidebar__list mt-3">
              <div className="comm-sidebar__section-label mx-2 px-2">
                <div className="left">
                  <label htmlFor="">Your Projects</label>
                </div>
              </div>

              <div className="comm-channels">
                {projects &&
                  projects.map((project, index) => {
                    const subchannelCount = project?.subchannel?.length || 0;
                    const totalUnread =
                      project?.subchannel?.reduce(
                        (sum, c) => sum + Number(c?.unread_count || 0),
                        0
                      ) || 0;
                    const isOpen = !!project?.submenu;
                    const groupClass = [
                      "comm-channels__group",
                      isOpen && "comm-channels__group--open",
                    ]
                      .filter(Boolean)
                      .join(" ");
                    return (
                      <div
                        className={groupClass}
                        key={"project" + project.channel_id}
                      >
                        <div
                          className="comm-channels__item"
                          onClick={() => {
                            setChannelId(project.channel_id);
                            if (project?.subchannel?.length > 0) {
                              const firstChannel = project.subchannel[0];
                              setSubChannelId(firstChannel.Team_Channel_Id);
                            }
                            setprojectIdTast(project.project_id);
                            socket &&
                              socket.emit("get-general-members", {
                                schannel_id:
                                  project.subchannel &&
                                  project.subchannel[0].Team_Channel_Id,
                              });
                            setCurrentTeam(
                              project.subchannel &&
                              project.subchannel[0].Team_Channel_Id
                            );
                            joinRoom(
                              project.subchannel &&
                              project.subchannel[0].Team_Channel_Id
                            );
                          }}
                        >
                          <Link
                            to="#"
                            className="comm-channels__item-main"
                            onClick={() => {
                              projects &&
                                setProjects(
                                  projects.map((proj, innerIndex) => {
                                    return {
                                      ...proj,
                                      submenu: proj.submenu
                                        ? !proj.submenu
                                        : innerIndex === index,
                                    };
                                  })
                                );
                            }}
                          >
                            <span
                              className="comm-channels__chevron"
                              aria-hidden="true"
                            >
                              <ChevronIcon />
                            </span>
                            <div className="comm-channels__item-tile">
                              <span className="comm-channels__item-tile-text">
                                {getProjectInitials(project?.channel_name)}
                              </span>
                            </div>
                            <div className="comm-channels__item-name">
                              {project.channel_name}
                            </div>
                            <div className="comm-channels__item-meta">
                              {totalUnread > 0 && (
                                <span
                                  className="comm-channels__count-badge"
                                  aria-label={`${totalUnread} unread`}
                                >
                                  {totalUnread > 99 ? "99+" : totalUnread}
                                </span>
                              )}
                            </div>
                          </Link>
                          <div className="comm-channels__item-actions">
                            <Dropdown>
                              <Dropdown.Toggle
                                as="button"
                                id={`project-actions-${project.channel_id}`}
                                className="comm-channels__item-action-toggle"
                                aria-label="Project actions"
                              >
                                <img src={more_vertical} alt="" />
                              </Dropdown.Toggle>
                              <Dropdown.Menu
                                as="ul"
                                className="comm-channels__item-menu"
                              >
                                <li
                                  className="comm-channels__item-menu-item"
                                  onClick={() => {
                                    setShowsubChannelModal(true);
                                    createSubChannelMember(project.channel_id);
                                  }}
                                >
                                  Add Sub-Project
                                </li>
                                <li
                                  className="comm-channels__item-menu-item"
                                  onClick={() => setShow(true)}
                                >
                                  View members
                                </li>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        </div>
                        {isOpen && (
                          <div className="comm-channels__sublist">
                            {subchannelCount > 0 &&
                              project.subchannel.map((channel) => {
                                const isActive =
                                  currentRoute === "/projects" &&
                                  currentSChannel === channel.Team_Channel_Id;
                                const hasUnread = channel.unread_count > 0;
                                const subItemClass = [
                                  "comm-channels__subitem",
                                  isActive && "comm-channels__subitem--active",
                                  hasUnread && "comm-channels__subitem--unread",
                                ]
                                  .filter(Boolean)
                                  .join(" ");
                                return (
                                  <Link
                                    to="/projects"
                                    className={subItemClass}
                                    onClick={() => {
                                      setSubChannelId(channel.Team_Channel_Id);
                                      isMobile
                                        ? setSidebar(false)
                                        : setSidebar(true);
                                      setActiveChat({
                                        pin: false,
                                        ...channel,
                                        project: project.channel_name,
                                        channel_name:
                                          channel.Team_Channel_Name,
                                        channel_id: channel.channel_id,
                                      });
                                      setCurrentSChannel(
                                        channel.Team_Channel_Id
                                      );
                                      joinRoom(
                                        channel?.Team_Channel_Id &&
                                        channel?.Team_Channel_Id
                                      );
                                    }}
                                    key={
                                      "Subchannel" + channel.Team_Channel_Id
                                    }
                                  >
                                    <span className="comm-channels__subitem-name">
                                      {channel.Team_Channel_Name}
                                    </span>
                                    {hasUnread && (
                                      <span className="comm-channels__subitem-meta">
                                        <span
                                          className="comm-channels__count-badge comm-channels__count-badge--sm"
                                          aria-label={`${channel.unread_count} unread`}
                                        >
                                          {channel.unread_count > 99
                                            ? "99+"
                                            : channel.unread_count}
                                        </span>
                                      </span>
                                    )}
                                  </Link>
                                );
                              })}
                            <button
                              type="button"
                              className="comm-channels__add-sub"
                              onClick={(e) => {
                                e.stopPropagation();
                                setChannelId(project.channel_id);
                                setShowsubChannelModal(true);
                                createSubChannelMember(project.channel_id);
                              }}
                            >
                              <span
                                className="comm-channels__add-sub-icon"
                                aria-hidden="true"
                              >
                                +
                              </span>
                              <span>Add Sub Channel</span>
                            </button>
                          </div>
                        )}
                      </div>
                    );
                  })}
              </div>
            </div>
            <div className="comm-divider mx2"></div>
            <div className="comm-sidebar__section-label px-3" id="invite-people">
              <div className="left">
                <label className="text-grey" htmlFor="">
                  Invite People
                </label>
              </div>
              <div className="right">
                <Link to="#">
                  <img src={arrow_right} alt="" className="pe-1" />
                </Link>
              </div>
            </div>
            <div className="comm-sidebar__section-label px-3" id="invite-people">
              <div className="left">
                <label
                  htmlFor=""
                  onClick={() => {
                    navigate("/Project?createProject=CreateProject");
                  }}
                >
                  Join or Create Project
                </label>
              </div>
              <div className="right">
                <Link to="#">
                  <img src={arrow_right} alt="" className="pe-1" />
                </Link>
              </div>
            </div>
          </aside>
          <main className="comm-layout__main">
            <ChatBox isIndivitual={false} />
          </main>
        </div>
      </div>
      {/* View memebers Modal */}
      <ViewMembersModal
        show={show}
        onHide={() => {
          setShow(false);
          setCurrentTeam(null);
          setMembers([]);
        }}
        members={teamMembers}
      />
      {/* Create Sub channel  Modal */}
      <CreateSubChannelModal
        show={showsubChannelModal}
        onHide={() => setShowsubChannelModal(false)}
        subChannelDetails={subChannelDetails}
        onChannelNameChange={(e) =>
          setSubChannelDetails({
            ...subChannelDetails,
            name: e.target.value,
          })
        }
        onChannelDescriptionChange={(e) =>
          setSubChannelDetails({
            ...subChannelDetails,
            description: e.target.value,
          })
        }
        memberOptions={SubchianlMemberList
          ?.map((suggetion) => ({
            id: suggetion.User_id,
            name: suggetion.FirstName + " " + suggetion.LastName,
          }))}
        onMemberSelect={onSelect}
        onMemberRemove={onRemove}
        onCancel={() => setShowsubChannelModal(false)}
        onSubmit={() => createSubChannel()}
        loading={loading}
      />
    </>
  );
};

export default ProjectChannels;
